import { SearchOutlined } from "@ant-design/icons";
import { Icon } from "@material-ui/core";
import { Button, Input, notification, Space } from "antd";
import axios from "axios";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import { FaSearch } from "react-icons/fa";
import { useHistory } from "react-router";
import { urlConfigVersaoApp } from "../../../../../services/request/urls";
import { getToken } from "../../../../../services/token";


export interface IAlteracoes {
    titulo: string;
    descricao: string;
    icone?: string;
    imagem?: string;
    fileIcone?: string;
    fileImage?: string;
}

const IconSearch = (props: any) => <Icon {...props} component={FaSearch} ></Icon>

export default function useListVersaoApp() {

    const formRef = useRef<any>(null);

    const history = useHistory();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<number>>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [dadosTabelaState, setDadosTabelaState] = useState([]);
    const [hasSelectedAdd, setHasSelectedAdd] = useState(true);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);
    const [hasSelectedDel, setHasSelectedDel] = useState(false);
    const [loadingFormAdd, setLoadingFormAdd] = useState(false);
    const [modalAddConfigVisible, setModalAddConfigVisible] = useState(false);

    const [valorDiasParaAtualizar, setValorDiasParaAtualizar] = useState('');
    const [valorBuildAndroid, setValorBuildAndroid] = useState('');
    const [valorBuildIos, setValorBuildIos] = useState('');
    const [valorNumero, setValorNumero] = useState('');
    const [alteracoes, setAlteracoes] = useState<IAlteracoes[]>([]);

    //State de editar usuario
    const [initialValueEditId, setInitialValueEditId] = useState<undefined | number>(undefined);

    //executa apenas ao iniciar o component
    useEffect(() => {
        setLoadingTable(true)
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlConfigVersaoApp,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });
                setDadosTabelaState(result.data);
                setLoadingTable(false)

            } catch (error) {

                let msgErro: any = (error as Error);

                setLoadingTable(false)
                notification.error({
                    message: 'Erro',
                    description:
                        msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel buscar os dados!',
                });
            }
        }

        buscaDeDados();

    }, []);

    //executa apenas quando salvar
    const salvarModalRecarregaTable = useCallback(() => {
        setLoadingTable(true)
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlConfigVersaoApp,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });
                setDadosTabelaState(result.data);
                setLoadingTable(false)
            } catch (error) {

                let msgErro: any = (error as Error);
                setLoadingTable(false)
                notification.error({
                    message: 'Erro',
                    description:
                        msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel buscar os dados!',
                });
            }
        }

        buscaDeDados();

    }, []);

    const handleSearch = useCallback((selectedKeys, confirm, dataIndex): void => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }, [searchText]);

    const handleReset = useCallback((clearFilters): void => {
        clearFilters();
        setSearchText('');
    }, []);

    const handleChangeAlteracoes = useCallback((alteracoes: IAlteracoes[]) => {
        setAlteracoes(alteracoes);

        alteracoes.length > 0 && formRef.current.setFieldsValue({ alteracoes_json: JSON.stringify(alteracoes) });
    }, []);

    //Search da tabela de listagem
    const getColumnSearchProps = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSearch style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any) =>
                record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchText, searchedColumn, handleSearch, handleReset]);

    // fim do search da tabela de listagem



    const clickBotaoDeletarDados = useCallback((): void => {
        const buscaDeDados = () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length == 1) {
                let obj: Array<object> = [];
                let resultforeach = dadosTabelaState.forEach(({ uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            obj.push({ id })
                        }
                    });

                })

                const excluirDadosModal = async () => {
                    try {
                        let resultCidade = await axios.delete(urlConfigVersaoApp, {
                            //EXEMPLO APENAS PARA EXCLUIR UM [0] ATE CORRIGIR O BACK
                            data: obj[0],
                            headers: { 'Authorization': 'Bearer ' + getToken() }
                        })
                        notification.success({
                            message: 'Sucesso',
                            description:
                                'Seus dados foram excluídos com sucesso!',
                        });
                        setLoadingFormAdd(false);
                        salvarModalRecarregaTable();
                        setInitialValueEditId(undefined);
                    } catch (error) {

                        let msgErro: any = (error as Error);

                        setLoadingFormAdd(false);
                        notification.error({
                            message: 'Erro',
                            description:
                                msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel deletar, entre em contato com suporte!',
                        });
                    }
                }
                excluirDadosModal();
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
                setSelectedRowKeys([]);

            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState, formRef]);

    const clickSubmitModalAddConfig = useCallback((): void => {

        formRef.current?.validateFields()
            .then((values: any) => {
                setLoadingFormAdd(true);

                values.build_ios = parseFloat(values.build_ios)
                values.build_android = parseFloat(values.build_android)
                values.dias_para_atualizar = parseFloat(values.dias_para_atualizar)
                values.numero = values.numero

                if (initialValueEditId) {
                    values.id = initialValueEditId;

                    const editarDadosModal = async () => {
                        try {
                            let resultCidade = await axios.put(urlConfigVersaoApp, values,
                                { headers: { 'Authorization': 'Bearer ' + getToken() } });
                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram editados com sucesso!',
                            });
                            setLoadingFormAdd(false);
                            salvarModalRecarregaTable();
                            clickCancelModalAddConfig();
                            setInitialValueEditId(undefined);
                        } catch (error) {
                            let msgErro: any = (error as Error);
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    editarDadosModal();
                } else {
                    const salvarDadosModal = async () => {
                        try {

                            let resultCidade = await axios.post(urlConfigVersaoApp, values,
                                { headers: { 'Authorization': 'Bearer ' + getToken() } });
                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram criados com sucesso!',
                            });
                            setLoadingFormAdd(false);
                            salvarModalRecarregaTable();
                            clickCancelModalAddConfig();
                        } catch (error) {
                            let msgErro: any = (error as Error);
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    salvarDadosModal();
                }
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
                setSelectedRowKeys([])

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, [initialValueEditId]);

    //Editar dados
    const clickBotaoEditarDados = useCallback((): void => {

        history.push({
            pathname: '/configuracoesdosistema/salvarversaoapp',
            state: { uuid: selectedRowKeys[0] }
        })
        return;

    }, [selectedRowKeys, dadosTabelaState, formRef]);

    const clickCancelModalAddConfig = useCallback(() => {
        setModalAddConfigVisible(false);
        formRef.current.resetFields();
    }, []);


    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.uuid)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.uuid
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(false);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.uuid]);
                setHasSelectedAdd(false);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else {
                let teste = selectedRowKeys.concat(record.uuid);
                setSelectedRowKeys(teste);
                setHasSelectedAdd(false);
                setHasSelectedEdit(false);
                setHasSelectedDel(true);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    const onSelectChange = useCallback((selectedRowKeys): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(false);
            setHasSelectedEdit(false);
            setHasSelectedDel(true);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(true);
            setHasSelectedEdit(false);
            setHasSelectedDel(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(false);
            setHasSelectedEdit(true);
            setHasSelectedDel(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const columns = [
        {
            title: 'Numero Versão',
            dataIndex: 'numero',
            ...getColumnSearchProps('numero'),
            width: '15%',
        },
        {
            title: 'Dias para atualizar',
            dataIndex: 'dias_para_atualizar',
            ...getColumnSearchProps('dias_para_atualizar'),
            width: '15%',
        },
        {
            title: 'Build IOS',
            dataIndex: 'build_ios',
            ...getColumnSearchProps('build_ios'),
            width: '15%',
        },
        {
            title: 'Build Android',
            dataIndex: 'build_android',
            ...getColumnSearchProps('build_android'),
            width: '15%',
        },
        {
            title: 'Criado em',
            dataIndex: 'created_at',
            ...getColumnSearchProps('created_at'),
            width: '20%',
            render: (criado: any) => (
                moment(criado).format('DD/MM/YYYY HH:mm:ss')
            ),
        },
        {
            title: 'Atualizado em',
            dataIndex: 'updated_at',
            ...getColumnSearchProps('updated_at'),
            width: '30%',
            render: (criado: any) => (
                moment(criado).format('DD/MM/YYYY HH:mm:ss')
            ),
        },
    ];

    const onClickVoltarConfigOfSystem = useCallback((): void => {
        history.push("/configuracoesdosistema");
    }, []);

    //Onchange inputs number
    const onChangeInputNumberDiasParaAtualizar = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9]*$/

        if (regex.test(originalValue)) {
            setValorDiasParaAtualizar(originalValue)
            formRef.current.setFieldsValue(
                { dias_para_atualizar: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { dias_para_atualizar: valorDiasParaAtualizar }
            );
        }
    }, [valorDiasParaAtualizar]);

    const onChangeInputNumberBuildAndroid = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorBuildAndroid(originalValue)
            formRef.current.setFieldsValue(
                { build_android: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { build_android: valorBuildAndroid }
            );
        }
    }, [valorBuildAndroid]);

    const onChangeInputNumberBuildIos = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorBuildIos(originalValue)
            formRef.current.setFieldsValue(
                { build_ios: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { build_ios: valorBuildIos }
            );
        }
    }, [valorBuildIos]);

    const onChangeInputNumberNumero = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorNumero(originalValue)
            formRef.current.setFieldsValue(
                { numero: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { numero: valorNumero }
            );
        }
    }, [valorNumero]);


    return {
        onClickVoltarConfigOfSystem,
        history,
        hasSelectedAdd,
        clickBotaoEditarDados,
        hasSelectedEdit,
        clickBotaoDeletarDados,
        loadingTable,
        onclickTable,
        rowSelection,
        columns,
        dadosTabelaState,
        modalAddConfigVisible,
        clickSubmitModalAddConfig,
        clickCancelModalAddConfig,
        loadingFormAdd,
        formRef,
        onChangeInputNumberNumero,
        onChangeInputNumberDiasParaAtualizar,
        onChangeInputNumberBuildIos,
        onChangeInputNumberBuildAndroid,
        handleChangeAlteracoes,
        alteracoes,
        valorNumero
    }

}
